import React, { Component, Fragment } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountStyles";
import PopupWrapper from "../components/PopupWrapper";
import AccountBackButton from "../components/AccountBackButton";
import DiscList from "../components/DiscList";
import Spacer from "../components/Spacer";
import AccountSubheader from "../components/AccountSubheader";

class AccountInfoCare extends Component {
  render() {
    const { account } = this.props;

    return (
      <div className={css(styles.container)}>
        <PopupWrapper />

        <header className={css(styles.header)}>
          <div className={css(styles.titleWrapper)}>
            <img
              src={"/icons/AccountIconLarge.svg"}
              className={css(styles.accountIcon)}
              alt=""
            />
            <h1 className={css(styles.title)}>Account</h1>
          </div>
          <AccountBackButton />
        </header>

        <main className={css(styles.mainContainer)}>
          <AccountSubheader title="InfoCare" />

          <DiscList
            title={"Tariff Details"}
            size={"small"}
            icon={"/icons/home-lightning-bolt-outline.svg"}
            subTitle={"Change tariff information"}
            href="/account/infocare/tariff"
          />

          <DiscList
            title={"Run Setup"}
            size={"small"}
            icon={"/icons/pencil.svg"}
            subTitle={"Re-run setup"}
            href="/setup?type=main"
          />

          <DiscList
            title={"Appliances"}
            size={"small"}
            icon={"/icons/kettle.svg"}
            subTitle={"Edit the appliances and their visibility"}
            href="/account/infocare/appliances"
          />

          <DiscList
            title={"Holiday Mode"}
            size={"small"}
            icon={"/icons/palm-tree.svg"}
            subTitle={"Enable for when the caree is on holiday"}
            href="/account/infocare/holiday-mode"
          />

          <DiscList
            title={"Alerts"}
            size={"small"}
            icon={"/icons/alert-outline.svg"}
            subTitle={"Change how you receive alerts"}
            href="/account/infocare/alerts"
          />

          <DiscList
            title={"Email Report"}
            size={"small"}
            icon={"/icons/email-newsletter.svg"}
            subTitle={"Receive a summary of alerts and activity"}
            href="/account/infocare/email-report"
          />
        </main>
      </div>
    );
  }
}

export default AccountInfoCare;
